module.exports = __webpack_public_path__ + "static/media/help.5f7bb690.svg";


//////////////////
// WEBPACK FOOTER
// ./src/topNav/help.svg
// module id = 2345
// module chunks = 0